import React, { useState, useEffect } from 'react';
import { Dialog, Button, Slide } from '@material-ui/core';

import { ToriiBotHalfWave } from '../Icons';
import styles from './styles';

interface Props {
  buttonText?: string;
  content: any;
  handleClose?: Function;
  isOpen: boolean;
}

function ToriiBotDialog(props: Props) {
  const classes = styles(props);
  const [open, setOpen] = useState(props.isOpen || false);

  useEffect(() => {
    setOpen(props.isOpen);
  }, [props.isOpen]);

  const handleClose = () => {
    setOpen(false);
    props.handleClose && props.handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{ paper: classes.dialogContainer }}
      style={{ margin: 0 }}
    >
      <Slide direction="up">
        <React.Fragment>
          <div className={classes.paper}>
            <ToriiBotHalfWave
              height={215}
              width={231}
              style={{ marginLeft: -20, marginBottom: -40 }}
            />
            <div className={classes.contentContainer}>
              <div className={classes.textContainer}>{props.content}</div>
              <Button className={classes.button} onClick={handleClose}>
                {props.buttonText || 'GOT IT'}
              </Button>
            </div>
          </div>
        </React.Fragment>
      </Slide>
    </Dialog>
  );
}

export default ToriiBotDialog;
